import script from "./TotalNetValueChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalNetValueChart.vue?vue&type=script&setup=true&lang=js"

import "./TotalNetValueChart.vue?vue&type=style&index=0&id=b1a23180&lang=less&scope=true"

const __exports__ = script;

export default __exports__